module.exports = __webpack_public_path__ + "static/media/ic-user.644ee9b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-user.svg
// module id = 679
// module chunks = 14